import React from "react";
import PropTypes from "prop-types";
import { Input } from "reactstrap";
import { NumberFormatInput } from "../../../NumberFormatInput/NumberFormatInput";

const Numeric = ({ value, onChange, dataTypeDecimalName, decimalScale, ...restProps }) => (
  <NumberFormatInput
    type="text"
    customInput={Input}
    value={formatNumber(value)}
    onValueChange={(e) => onChange(isNaN(e.floatValue) ? e.value : e.floatValue)}
    dataTypeDecimalName={dataTypeDecimalName}
    decimalScale={decimalScale}
    {...restProps}
  />
);

Numeric.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
};

const formatNumber = (value) => {
  if (isNaN(value) || value === "") {
    return "";
  } else {
    return parseFloat(value);
  }
};

export default React.memo(Numeric);
